import React from 'react';
import { Modal, Typography } from 'antd';
import { LoginForm } from './LoginForm';

interface LoginModalProps {
  open: boolean;
  onClose: () => void;
}

export const LoginModal: React.FC<LoginModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={480}
      centered
      title={<Typography.Title level={3} style={{ marginBottom: 0 }}>Login</Typography.Title>}
      destroyOnClose
    >
      <div style={{ padding: '8px 0' }}>
        <LoginForm compact onSuccess={onClose} />
      </div>
    </Modal>
  );
};
